<template>
  <div class="container-table">
    <!-- Table -->
    <table
      id="dataTable"
      :class="`dataTable table ${tableClass}`">
      <!-- Slot THead -->
      <slot name="thead">
        <thead>
          <tr>
            <th
              v-for="(value, index) in fields"
              :key="index">
              {{ value }}
            </th>
          </tr>
        </thead>
      </slot>
      <!-- Slot TBody -->
      <slot name="tbody">
        <tbody>
          <!-- Not found data -->
          <tr>
            <td
              v-if="items.length === 0"
              :colspan="items.length"
              class="text-center">
              {{ $t('message.notfounddata') }}
            </td>
          </tr>
          <!-- Columns -->
          <tr
            v-for="(columns, columnsIndex) in items"
            :key="columnsIndex">
            <td
              v-for="(value, index) in columns"
              :key="index">
              {{ value }}
            </td>
          </tr>
        </tbody>
      </slot>
    </table>
    <div
      v-if="!hidePagination"
      class="d-flex justify-content-end">
      <!-- Total Rows -->
      <div class="col d-flex align-items-center">
        {{ $t('message.rows', { number: pagination.totalRows }) }}
      </div>
      <!-- Pagination -->
      <b-pagination
        :value="pagination.currentPage"
        :totalRows="pagination.totalRows"
        :perPage="pagination.perPage"
        class="pagination"
        @change="handlePageChange"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseTable',

  props: {
    fields: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    // { currentPage: 1, totalRows: 250, perPage: 10 }
    pagination: {
      type: Object,
      default: () => ({}),
    },
    tableClass: {
      type: String,
      default: '',
    },
    hidePagination: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    handlePageChange (pageNum) {
      this.$emit('onPageChange', pageNum)
    },
  },
}
</script>

<style scoped>
  .pagination {
    margin-top: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/components/base/BaseTable.vue